import Image from "next/image";
import Link from "next/link";
import type { Media } from "@/payload-types";
import { siteConfig } from "@/lib/site.config";

/**
 * Shared Logo Component
 *
 * Renders either an image logo or text logo based on what's configured
 * in the Navigation global.
 */

interface LogoProps {
  /** Media object from Payload or null */
  logo?: Media | string | number | null;
  /** Text to display if no logo image */
  logoText?: string | null;
  /** Additional CSS classes */
  className?: string;
  /** Whether to wrap in a Link to home */
  asLink?: boolean;
  /** Image dimensions */
  width?: number;
  height?: number;
}

export function Logo({ 
  logo, 
  logoText, 
  className = "",
  asLink = true,
  width = 140,
  height = 35
}: LogoProps) {
  const logoContent = (
    <>
      {logo && typeof logo === "object" ? (
        <Image
          src={logo.url || ""}
          alt={logo.alt || logoText || "Logo"}
          width={width}
          height={height}
          className={className || "h-9 w-auto"}
          priority // Logo is above the fold
          sizes={`${width}px`}
        />
      ) : (
        <span className={className || "font-heading text-2xl text-white"}>
          {logoText || siteConfig.name}
        </span>
      )}
    </>
  );

  if (asLink) {
    return (
      <Link href="/" className="flex items-center space-x-2">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
}
